import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { clearError, setError } from "./uiSlice";
import {
  fetchGetAllBlogs,
  fetchGetBlogById,
  fetchWriteBlog,
} from "../api/blogAPI";

export const getAllBlogs = createAsyncThunk(
  "blogs/getAllBlogs",
  async (type = null, { rejectWithValue, dispatch }) => {
    try {
      const result = await fetchGetAllBlogs();
      if (!result.success) {
        dispatch(setError(result.message || "Failed to get blogs data"));
        return rejectWithValue(result.message);
      }
      dispatch(clearError());
      return result.blogs;
    } catch (err) {
      dispatch(setError("Failed to get blogs data."));
      return rejectWithValue(err.message);
    }
  }
);

export const writeBlog = createAsyncThunk(
  "blogs/writeBlog",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const result = await fetchWriteBlog(payload);
      return result;
    } catch (err) {
      dispatch(setError("Failed to post blog."));
      return rejectWithValue(err.message);
    }
  }
);

export const getBlogById = createAsyncThunk(
  "blog/getBlogById",
  async (blogId, { rejectWithValue, dispatch }) => {
    try {
      const result = await fetchGetBlogById(blogId);
      if (!result.success) {
        dispatch(setError(result.message || "Failed to get blog details"));
        return rejectWithValue(result.message);
      }
      return result.data;
    } catch (err) {
      dispatch(setError("Failed to get blog details."));
      return rejectWithValue(err.message);
    }
  }
);

const blogSlice = createSlice({
  name: "blog",
  initialState: {
    blogs: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearBlogError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllBlogs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllBlogs.fulfilled, (state, action) => {
        state.loading = false;
        state.blogs = action.payload;
      })
      .addCase(getAllBlogs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(writeBlog.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(writeBlog.fulfilled, (state, action) => {
        state.loading = false;
        state.blogs.push(action.payload.data);
      })
      .addCase(writeBlog.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error?.message || "Failed to create job";
      })
      .addCase(getBlogById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getBlogById.fulfilled, (state, action) => {
        state.loading = false;
        state.blogs = action.payload;
      })
      .addCase(getBlogById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearBlogError } = blogSlice.actions;
export default blogSlice.reducer;
